class CartWeightWarning extends HTMLElement {
  #unsubscribe = null;
  #blockG = null;

  connectedCallback() {
    const maxKg = Number(this.dataset.maxWeightKg);
    this.#blockG = maxKg > 0 ? maxKg * 1000 : null;

    this.#sync();
    this.#unsubscribe = subscribe('cart-update', () => this.#sync());
  }

  disconnectedCallback() {
    this.#unsubscribe?.();
  }

  async #sync() {
    if (!this.#blockG) return; // no tiers configured — nothing to block

    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      const { total_weight } = await res.json();
      const blocked = total_weight > this.#blockG;
      this.hidden = !blocked;
      document
        .querySelectorAll('#checkout, #CartDrawer-Checkout')
        .forEach((btn) => btn.toggleAttribute('disabled', blocked));
    } catch {
      // Network error — leave current state
    }
  }
}

if (!customElements.get('cart-weight-warning')) {
  customElements.define('cart-weight-warning', CartWeightWarning);
}
